import React, {useContext, useEffect} from 'react';
import {observer} from 'mobx-react';
import momentTimezone from 'moment-timezone';
import 'moment/locale/pt-br';
import {of} from 'rxjs';
import {mergeAll, mergeMap} from 'rxjs/operators';
import {ThemeContext} from '../../apiContexts';
import useSocket from '../../hooks/use-socket';
import useNotificationType from '../../hooks/use-notification-type';
import useStore from '../../hooks/use-store';
import EventList from '../../views/event';
import useTimezone from '../../hooks/use-timezone';

const EventContainer = (props) => {
    const theme = useContext(ThemeContext);
    const {store} = useStore();
    const {events, devices} = store;
    const {timezone} = useTimezone();
    const {events: eventsSocket} = useSocket();
    const {types} = useNotificationType();

    useEffect(() => {
        eventsSocket
            .pipe(
                mergeAll(),
                mergeMap(
                    ({deviceId}) => of(devices.findById(deviceId)),
                    ({serverTime, ...e}, d) => ({
                        name: d ? d.name : '',
                        serverTime: momentTimezone(serverTime)
                            .tz(timezone)
                            .format(),
                        ...e,
                    }),
                ),
            )
            .subscribe((event) => {
                events.add(event);
            });
    }, []);

    const enableDisableSound = () => {
        const enabled = events.getEnabledSound();
        events.setEnableSound(!enabled);
    };

    return (
        <EventList
            theme={theme}
            eventTypes={types}
            removeAll={events.removeAll}
            events={events.toList}
            enableDisableSound={enableDisableSound}
            isSoundEnabled={events.getEnabledSound()}
        />
    );
};

export default observer(EventContainer);
